import { DAY_OF_WEEK } from '@app/constants/week'

import type { DayOfWeek } from '@app/types'

export const getDayOfWeekByNumber = (dayOfWeeNumber: number): DayOfWeek | undefined => {
  return DAY_OF_WEEK[dayOfWeeNumber as keyof typeof DAY_OF_WEEK]
}
